import { FormControl, FormGroup } from "@angular/forms";
import { DeviceBase } from "./device-base";
import { PropertyMetadata } from "../../properties/property-types";
import { RegisterElement } from "../element-decorator";
import { ParkingLevelElement } from "../parking/parkinglevel";
import { ElementValidationResult, LevelDesignerElementBase } from "../element-base";

@RegisterElement()
export class CarCounter extends DeviceBase {
    protected sizeInMeters: number = 1;
    public override TypeName: string = "CarCounter";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "CarCounterConfigurations";

    constructor(formGroup: FormGroup) {
        super(formGroup, 'assets/icons/carcounter.svg');

        const idValue = formGroup.get('Id')?.value;
        if (idValue && typeof idValue !== 'number') {
            formGroup.get('Id')?.setValue(null);
        }
        if (!formGroup.contains('ChipId')) {
            formGroup.addControl('ChipId', new FormControl(null));
        }
    }

    public override clone(): CarCounter {
        return new CarCounter(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'ChipId',
                displayName: 'Chip ID',
                inputType: { 
                    type: 'searchable-select',
                    url: '/hardware/carcounters/available/searches',
                    idProperty: 'ChipId',
                    labelProperty: 'ChipId',
                    minSearchLength: 2
                },
                order: 3,
                category: 'Hardware',
                hideOnMultipleSelection: true,
            }
        ];
    }

    public override default(): CarCounter {
        return this;
    }

} 
